var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAircraftFamily = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 4.22,3.67 L 8.67,3.67 L 12,7 L 19.78,7 A 2.22,2.22 0 0,1 22,9.22 L 22,18.11 A 2.22,2.22 0 0,1 19.78,20.33 L 4.22,20.33 A 2.22,2.22 0 0,1 2,18.11 L 2,5.89 A 2.22,2.22 0 0,1 4.22,3.67",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 12,8.65 C 12.58,8.65 12.99,9.23 12.99,9.99 L 12.99,12.44 L 16.67,14.54 L 16.67,15.71 L 12.99,14.66 L 12.99,16.76 L 14.16,17.69 L 14.16,18.68 L 12,18.1 L 9.84,18.68 L 9.84,17.69 L 11.01,16.76 L 11.01,14.66 L 7.33,15.71 L 7.33,14.54 L 11.01,12.44 L 11.01,9.99 C 11.01,9.23 11.42,8.65 12,8.65 L 12,8.65",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAircraftFamily, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/aircraft-family.6c3a48b7.svg";
export { ForwardRef as ReactComponent };